import get from 'lodash/get'

export const getMaxChannelManagerAllowed = (channelData) => {

  const features = get(channelData, 'features')
  if (!features) {

    return false

  }

  const enabledFeature = channelData.features.find(({ name, enabled, value }) => name === 'channelManagers' && enabled === true)
  if (!enabledFeature) {

    return false

  }

  return enabledFeature.value

}
